import { AllMessageMedium, CampaignState, CampaignType } from 'modules/domains/campaign';

import { WhatsApp } from 'constants/messageMediums';
import {
  CAMPAIGN_STATE_BADGE_VARIANT_MAPPER,
  SCHEDULED_CAMPAIGN_TYPES,
  TRIGGERED_CAMPAIGN_TYPES,
} from '../constants';

/**
 * Returns whether a campaign is a triggered campaign
 * @param campaignType
 */
export const getIsTriggeredCampaignType = (campaignType: CampaignType) =>
  TRIGGERED_CAMPAIGN_TYPES.includes(campaignType);

/**
 * Returns whether a campaign is of a type that is able to be scheduled
 * @param campaignType
 */
export const getIsScheduledCampaignType = (campaignType: CampaignType) =>
  SCHEDULED_CAMPAIGN_TYPES.includes(campaignType);

/**
 * Returns the badge variant for a given campaign state
 * @param campaignState
 */
export const getCampaignStateBadgeVariant = (campaignState: CampaignState) =>
  CAMPAIGN_STATE_BADGE_VARIANT_MAPPER[campaignState] ??
  CAMPAIGN_STATE_BADGE_VARIANT_MAPPER.Finished;

export const getIsWhatsAppCampaign = (messageMedium: AllMessageMedium) =>
  messageMedium === WhatsApp;
